export enum UserGroupType {
  TrainingProgramStakeholders = 1,
}
